/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import { ActionInstance } from "../../../models/action-instance";
import { InstanceData } from "../../../models/instance-data";
import { PropertyType } from "../../../models/property-type";
import {Component, Input, OnInit} from "@angular/core";

declare var $: any;

@Component({
  selector: 'app-default-action-editor',
  templateUrl: './default-action-editor.component.html'
})
export class DefaultActionEditorComponent implements OnInit {
  
  mPropertyTypes = PropertyType;
  
  @Input()
  mAction: ActionInstance;
  
  ngOnInit(): void {
    console.log("onInit() - Action: " + (this.mAction == null? "*NULL*" : this.mAction.action == null? "*NULL-ACTION*" : (this.mAction.action.id + "/" + this.mAction.action.name)));
  
    //Build Data for each Property that doesn't already have Data defined for it, the Data is what is modeled in the UI for editing
    for (const property of this.mAction.action.properties) {
      if (this.mAction.data == null || this.mAction.data.find(d => d.property.property == property.property) == null) {
        const newData = new InstanceData();
        newData.property = property;
        if (this.mAction.data == null) {
          this.mAction.data = [ newData ];
        } else {
          this.mAction.data.push(newData);
        }
      }
    }
    
    //Sort the Data by their corresponding property order
    this.mAction.data.sort((data1: InstanceData, data2: InstanceData): number => {
      return data1.property.order - data2.property.order;
    });
  }

}
